module.exports = __webpack_public_path__ + "img/vc5.dffa265e.png";